@if (visible()) {
  <section
    class="flex flex-col gap-3 rounded-lg border border-greyscale-200 bg-primary-50 p-2 md:p-4"
    aria-labelledby="trip-goals-title"
  >
    <h2 id="trip-goals-title" class="text-heading-4 font-bold text-primary-900">
      {{ "reductionTips.goals.title" | transloco }}
    </h2>

    <div class="grid grid-cols-1 gap-3" [class.lg:grid-cols-2]="bothCards()">
      @if (objectives().length > 0) {
        <div class="rounded-lg bg-white p-3 md:p-4">
          <p class="mb-2 text-paragraph-xs-reg font-medium text-greyscale-600">
            {{ "reductionTips.goals.objectivesLabel" | transloco }}
          </p>
          <!-- One grid for every objective, so the values share a column and
               the gauges all get the same width. -->
          <ul class="grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-3">
            @for (obj of objectives(); track obj.type) {
              <!-- Two lines: what is aimed at, then where the trip stands. The
                   unit is spelled out once, on the target: the value only
                   keeps kg or t, which can differ from the target's. -->
              <li class="col-span-2 grid grid-cols-subgrid gap-y-1">
                <p
                  class="col-span-2 flex flex-wrap items-baseline justify-between gap-x-3 text-paragraph-xs-reg"
                >
                  <span class="font-medium text-greyscale-800">
                    {{ obj.labelKey | transloco }}
                  </span>
                  <span class="tabular-nums text-greyscale-600">
                    {{
                      "reductionTips.goals.targetShort"
                        | transloco
                          : {
                              target:
                                formatCo2e.format(obj.target) +
                                (obj.unitKey | transloco),
                            }
                    }}
                  </span>
                </p>
                <div
                  class="relative h-2 self-center rounded-full bg-greyscale-100"
                >
                  <div
                    class="h-full rounded-full bg-greyscale-400"
                    [style.width.%]="barWidthPercent(obj)"
                  ></div>
                  <div
                    class="absolute top-[-4px] h-[calc(100%+8px)] w-0.5 -translate-x-1/2 bg-greyscale-800"
                    [style.left.%]="markerPercent(obj)"
                    [attr.title]="'reductionTips.goals.marker' | transloco"
                  ></div>
                </div>
                <span
                  class="flex items-center justify-end gap-1.5 tabular-nums"
                >
                  <span
                    class="text-paragraph-s-reg font-semibold text-primary-900"
                  >
                    {{ formatCo2e.format(obj.value) }}
                  </span>
                  <span
                    class="rounded-full px-2 text-paragraph-xs-reg font-semibold"
                    [class]="badgeStyle(obj)"
                  >
                    {{ obj.isAboveTarget ? "+" : "−"
                    }}{{ obj.differencePercent }}%
                  </span>
                </span>
              </li>
            }
          </ul>
        </div>
      }

      @if (commitments().length > 0) {
        <div class="rounded-lg bg-white p-3 md:p-4">
          <p class="mb-2 text-paragraph-xs-reg font-medium text-greyscale-600">
            {{ "reductionTips.goals.commitmentsLabel" | transloco }}
          </p>
          <ul class="flex flex-col gap-1.5">
            @for (commitment of commitments(); track commitment.action) {
              <li class="grid grid-cols-[20px_minmax(0,1fr)] items-start gap-2">
                <span
                  class="flex h-5 w-5 items-center justify-center rounded-full"
                  [class]="statusStyle[commitment.status].badge"
                >
                  <lucide-icon
                    [name]="statusStyle[commitment.status].icon"
                    [size]="12"
                  />
                </span>
                <!-- Title and status on one line: the list is a summary, the
                     tips below each category carry the detail. -->
                <p class="min-w-0 text-paragraph-s-reg">
                  <span
                    class="font-semibold"
                    [class]="
                      commitment.status === 'not_applicable'
                        ? 'text-greyscale-500'
                        : 'text-primary-900'
                    "
                  >
                    {{
                      "objectives.reductionActions." +
                        commitment.action +
                        ".title" | transloco
                    }}
                  </span>
                  <span class="text-paragraph-xs-reg text-greyscale-600">
                    ·
                    <span
                      class="font-semibold"
                      [class]="statusStyle[commitment.status].text"
                    >
                      {{
                        "reductionTips.goals.status." + commitment.status
                          | transloco
                      }}
                    </span>
                    @if (commitment.elements.length > 0) {
                      · {{ commitment.elements.join(", ") }}
                    }
                  </span>
                </p>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </section>
}
